import React, { useState } from "react";
import { Column, useFilters, useGlobalFilter, useSortBy, useTable } from "react-table";
import { generalFilter, useDefaultColumn } from "../../../util/filter";
import moment from "moment";
import MuiTable from "@material-ui/core/Table";
import { Grid, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme, Link as MuiLink, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@material-ui/core";
import ScreenWidth from "../../common/ScreenWidth";
import { StatusViewTable } from "./StatusViewTable";




export const PreWritterTable = ({ data, refetch }: any) => {


    const defaultColumn = useDefaultColumn();
    const theme = useTheme();
    const widthCurrent = ScreenWidth();

    const columns: any[] = React.useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
                filter: generalFilter,
            },
            {
                id: "Report Type",
                accessor: "report_type_definition_name",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
            },
            {
                id: "Project Number",
                accessor: "project_number",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },

            {
                id: "Customer Name",
                accessor: "customer_name",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
            },

            {
                id: "BOM",
                accessor: "bom",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "Procedure Definition Name",
                accessor: "procedure_definition_name.procedure_definition_name",
                filter: generalFilter,
                width: 350,
                minWidth: 300,
                maxWidth: 350,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "Report Writer",
                accessor: "report_writer_name",
                filter: generalFilter,
                width: 350,
                minWidth: 300,
                maxWidth: 350,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "Status",
                accessor: "status",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value,row }: any) => {
                    const [open, setOpen] = useState(false)

                    const handleClose =()=>{
                        return setOpen(false)
                    }

                    const {id} = row.original
                    return (
                        <>

                            <MuiLink style={{ cursor: "pointer" }} onClick={() => setOpen(true)} >
                                {value ? value : "N/A"}
                            </MuiLink>

                            <Dialog open={open} onClose={handleClose} fullWidth maxWidth= "lg">
                                <DialogTitle>
                                    Status View
                                </DialogTitle>
                                <DialogContent>
                                    <StatusViewTable reportId={id} />

                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClose} style={{ marginTop: "20px",marginBottom:"20px"}} variant="outlined" color="primary" >Close</Button>
                                    
                                </DialogActions>

                            </Dialog>
                        </>


                    )
                }
            },


        ],
        []
    );


    const { getTableProps, visibleColumns, headerGroups, rows, prepareRow } =
        useTable(
            {
                data: data || [],
                columns,
                defaultColumn,
                initialState: {
                    hiddenColumns: ["id"],

                },
            },
            useFilters,
            useGlobalFilter,
            useSortBy,

        );




    return (
        <>

            <TableContainer
                data-testid="tableContainer"
                style={{
                    ...theme.tableContainer,
                    maxHeight: "500px",
                    overflowX: 'auto',
                    overflowY: 'auto',
                    whiteSpace: 'nowrap',
                    maxWidth: `${widthCurrent}px`
                }}
                component={Paper}
            >
                <MuiTable stickyHeader {...getTableProps()} size="small">
                    <TableHead>
                        {headerGroups.map((headerGroup) => (
                            <TableRow {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <TableCell
                                        style={{
                                            // ...theme.noLeftRightPadding,
                                            width: column.width,
                                            minWidth: column.minWidth,
                                            maxWidth: column.maxWidth,
                                            textAlign: 'center',
                                        }}
                                    >

                                        <Grid
                                            container
                                            direction="row"
                                            alignItems="center"
                                            spacing={0}
                                        >
                                            <Grid item xs={12} {...column.getHeaderProps()}>
                                                <Grid
                                                    container
                                                    direction="row"
                                                    alignItems="center"
                                                    spacing={0}
                                                >
                                                    <Typography
                                                        variant="subtitle2"
                                                        style={{ textAlign: "center", width: "100%", verticalAlign: "middle" }}
                                                    >
                                                        {column.render("Header")}
                                                    </Typography>
                                                    {column.canFilter ? column.render("Filter") : null}

                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableHead>
                    <TableBody style={{ minHeight: "400px" }}>
                        {rows.map((row) => {
                            prepareRow(row);
                            return (
                                <TableRow {...row.getRowProps()} style={{ height: 60 }}>
                                    {row.cells.map((cell) => (
                                        <TableCell {...cell.getCellProps()}>
                                            {cell.render("Cell")}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            );
                        })}
                    </TableBody>

                </MuiTable>
            </TableContainer>


        </>
    )
}